import { Link } from 'react-router-dom'
import Seo from '../../components/Seo'
import { categories, figures, hero, principles, sampleEngagement, sectors, services, testimonials } from '../../content'

export default function Home() {
  return (
    <>
      <Seo />
      <section className="hero hero-ruled" aria-labelledby="hero-title">
        <span className="eyebrow">{hero.eyebrow}</span>
        <h1 id="hero-title" style={{ marginTop: '0.75rem' }}>
          {hero.title}
        </h1>
        <p className="lede">{hero.lede}</p>
        <div className="hero-actions">
          <Link to="/contact" className="btn">
            {hero.primaryCta}
          </Link>
          <Link to="/clients" className="text-link">
            {hero.secondaryCta}
          </Link>
        </div>
      </section>

      <section className="section figures-section" aria-label="Track record">
        <div className="facts">
          {figures.map((f) => (
            <div className="fact" key={f.label}>
              <span className="eyebrow">{f.label}</span>
              <strong>{f.value}</strong>
              <p className="muted">{f.note}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" aria-labelledby="services-title">
        <div className="section-head">
          <span className="eyebrow">Services</span>
          <h2 id="services-title">What we do</h2>
        </div>
        <ul className="ledger unnumbered">
          {services.map((s) => (
            <li className="ledger-row" key={s.name}>
              <h3>{s.name}</h3>
              <p className="what">{s.what}</p>
              <div className="outcome">
                <span className="eyebrow">Outcome</span>
                {s.outcome}
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section className="section" aria-labelledby="sectors-title">
        <div className="two-col">
          <div>
            <span className="eyebrow">Sectors</span>
            <h2 id="sectors-title" style={{ marginTop: '0.5rem' }}>
              Who we work with
            </h2>
            <ul className="plain-list">
              {sectors.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>
          <div>
            <span className="eyebrow">Categories</span>
            <h2 style={{ marginTop: '0.5rem' }}>What we source</h2>
            <ul className="plain-list">
              {categories.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section" aria-labelledby="principles-title">
        <div className="section-head">
          <span className="eyebrow">Principles</span>
          <h2 id="principles-title">How we work</h2>
        </div>
        <div className="principles">
          {principles.map((p) => (
            <div className="principle" key={p.name}>
              <h3>{p.name}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" aria-labelledby="case-title">
        <div className="section-head">
          <span className="eyebrow">{sampleEngagement.eyebrow}</span>
          <h2 id="case-title">{sampleEngagement.title}</h2>
          <p className="lede">{sampleEngagement.summary}</p>
        </div>
        <div className="case">
          <dl className="case-table">
            {sampleEngagement.rows.map(([k, v]) => (
              <div key={k}>
                <dt>{k}</dt>
                <dd className="mono">{v}</dd>
              </div>
            ))}
          </dl>
          <p className="case-result">{sampleEngagement.result}</p>
        </div>
      </section>

      <section className="section" aria-labelledby="voices-title">
        <div className="section-head">
          <span className="eyebrow">Client perspectives</span>
          <h2 id="voices-title">What clients say</h2>
        </div>
        <div className="testimonials">
          {testimonials.map((t) => (
            <figure className="testimonial" key={t.quote}>
              <blockquote>
                <p>“{t.quote}”</p>
              </blockquote>
              <figcaption>
                <strong>{t.name}</strong>
                <span>{t.company}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="section" aria-labelledby="cta-title">
        <div className="section-head">
          <span className="eyebrow">Start</span>
          <h2 id="cta-title">Begin with a conversation about your spend</h2>
          <p className="lede">
            A short discussion of the categories in scope, the scale of spend, and your timeline is enough for us to
            propose a diagnostic or a focused sourcing programme.
          </p>
        </div>
        <Link to="/contact" className="btn">
          {hero.primaryCta}
        </Link>
      </section>
    </>
  )
}
